<template>
    <div v-show="visible">
        <el-dialog title="修改规则" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose"  width="660px">    
            <el-form ref="form" :model="form" :rules="rules" label-width="120px">
                <el-form-item prop="name" label="考勤组名称:" > 
                    <el-input style="width:200px;" v-model="form.name" maxlength="20"  placeholder=""></el-input> 
                </el-form-item>
                <el-form-item prop="partakeAttendant" label="参与考勤人员:">
                    <el-button @click="getMoreUser(1)">{{form.partakeAttendantLabel}}</el-button>
                </el-form-item>
                <el-form-item prop="notPartakeAttendant" label="无需考勤人员:">
                    <el-button @click="getMoreUser(2)">{{form.notPartakeAttendantLabel}}</el-button>
                </el-form-item>
                <el-form-item prop="attendaceController" label="考勤组负责人:">
                    <el-button @click="getSingleUser()">{{form.attendaceControllerLabel}}</el-button>
                </el-form-item>
                <el-form-item prop="type" label="考勤类型:">
                    <el-select v-model="form.type" placeholder="请选择" style="width:200px;">
                        <el-option
                            v-for="item in types"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="" label="工作日设置:">
                   <span  style="font-size:10px;">
                       快捷设置班次：班次{{this.classes.name}}：{{this.classes.oneCommuteTime}}
                       <span v-if="this.classes.twoCommuteTime !=null && this.classes.twoCommuteTime!=''">
                           &nbsp;{{this.classes.twoCommuteTime}}
                       </span>
                        <span v-if="this.classes.threeCommuteTime !=null && this.classes.threeCommuteTime!=''">
                           &nbsp;{{this.classes.threeCommuteTime}}
                       </span>
                   </span>
                   <el-button type="text" @click="setClasses('','',1)">更改班次</el-button>
                    <el-table
                        :data="workDates"
                        ref="multipleTable"
                        height="230"
                        border
                        @select="handleSelect"
                        @select-all="selectAll"
                        style="width: 480px;">
                        <el-table-column prop="selecCheck" type="selection" width="30" ></el-table-column>
                        <el-table-column prop="name" label="工作日" width="100"> </el-table-column>
                        <el-table-column prop="workStatus" label="班次时间段" width="249">
                            <template slot-scope="scope">
                                <div v-if="scope.row.workStatus == 1">
                                    班次{{scope.row.className}}:
                                    <div v-if="scope.row.classesType == 1">
                                        {{scope.row.oneCommuteTime}}
                                    </div>
                                    <div v-else-if="scope.row.classesType == 2">
                                        {{scope.row.oneCommuteTime}}&nbsp;{{scope.row.twoCommuteTime}}
                                    </div>
                                    <div v-else-if="scope.row.classesType == 3">
                                        {{scope.row.oneCommuteTime}}&nbsp;{{scope.row.twoCommuteTime}}&nbsp;{{scope.row.threeCommuteTime}}
                                    </div>
                                    <div v-else>
                                        无
                                    </div>
                                </div>
                                <div v-else-if="scope.row.workStatus == 2">
                                    休息
                                </div>
                                <div v-else>
                                    无
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column  width="100" label="操作">
                            <template slot-scope="scope">
                                <el-button style="color: #387EE8" @click.native.prevent="setClasses(scope.row.classesId,scope.$index,2)"
                                    type="text"
                                    size="small">
                                    更改班次
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-checkbox v-model="form.holidayFlag">法定节假日自动排休</el-checkbox>
                </el-form-item>
                <el-form-item prop="" label="特殊日期:">
                    <el-button @click="getAddDateClasses()">添加</el-button>&nbsp;<span style="font-size:12px;color:#BBBBBB">必须打卡的日期</span>
                    <el-table
                        :data="specialDates1"
                        height="150"
                        border
                        style="width: 480px;">
                        <el-table-column prop="date" label="日期" width="100"> </el-table-column>
                        <el-table-column prop="" label="考勤时间" width="249">
                            <template slot-scope="scope">
                                班次{{scope.row.className}}:
                                <div v-if="scope.row.classesType == 1">
                                    {{scope.row.oneCommuteTime}}
                                </div>
                                <div v-else-if="scope.row.classesType == 2">
                                    {{scope.row.oneCommuteTime}}&nbsp;{{scope.row.twoCommuteTime}}
                                </div>
                                <div v-else-if="scope.row.classesType == 3">
                                    {{scope.row.oneCommuteTime}}&nbsp;{{scope.row.twoCommuteTime}}&nbsp;{{scope.row.threeCommuteTime}}
                                </div>
                                <div v-else>
                                    无
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column  width="100" label="操作">
                            <template slot-scope="scope">
                                <el-button style="color: #red;" @click.native.prevent="delDateClasses(scope.$index)"
                                    type="text"
                                    size="small">
                                    删除
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form-item>
                <el-form-item prop="" label="">
                    <el-button @click="getAddDate()">添加</el-button>&nbsp;<span style="font-size:12px;color:#BBBBBB">不用打卡的日期</span>
                    <el-table
                        :data="specialDates2"
                        height="150"
                        border
                        style="width: 480px;">
                        <el-table-column prop="date" label="日期" width="100"> </el-table-column>
                        <el-table-column prop="" label="考勤时间" width="249">休息</el-table-column>
                        <el-table-column  width="100" label="操作">
                            <template slot-scope="scope">
                                <el-button style="color: #red;" @click.native.prevent="delDate(scope.$index)"
                                    type="text"
                                    size="small">
                                    删除
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span>    
        </el-dialog>

        <!-- 更改班次弹出框 -->
        <div v-if="classesVisible">
            <classes ref="classes"></classes>
        </div>
        <!-- 人员弹出框多人 -->
        <div v-if="userTransferMoreVisible">
            <userTransferMore ref="userTransferMore"></userTransferMore>
        </div>
        <!-- 人员弹出框单人 -->
        <div v-if="userTransferSingleVisible">
            <userTransferSingle ref="userTransferSingle"></userTransferSingle>
        </div>
        <!-- 必须打卡日期弹出框 -->
        <div v-if="addDateClassesVisible">
            <addDateClasses ref="addDateClasses"></addDateClasses>
        </div>
        <!-- 不用打卡日期弹出框 -->
        <div v-if="addDateVisible">
            <addDate ref="addDate"></addDate>
        </div>
    </div>
</template>
       
<script>
    import http from '../../../../common/http';
    import classes from './Classes.vue';
    import userTransferMore from '../../sys/user/UserTransfer.vue';
    import userTransferSingle from '../../sys/user/UserTransfer.vue';
    import addDateClasses from './AddDateClasses.vue';
    import addDate from './AddDate.vue';
    import {banBackSpace} from '../../../../common/preventBackspace';// backspace退格

    export default {
        data(){
            return{
                visible: false,
                classesVisible:false,
                userTransferMoreVisible:false,
                userTransferSingleVisible:false,
                addDateClassesVisible:false,
                addDateVisible:false,
                form:{
                    id:"",
                    deptId:"",
                    name:"",
                    partakeAttendant:[],
                    partakeAttendantLabel:"请选择",
                    notPartakeAttendant:[],
                    notPartakeAttendantLabel:"请选择",
                    attendaceController:[],
                    attendaceControllerLabel:"请选择",
                    classesId:"",
                    type:1,
                    holidayFlag:true,
                    workDates:[],
                    specialDates1:[],
                    specialDates2:[]
                },
                rules: {
                    name: [
                        { required: true, message: '请输入考勤组名称', trigger: 'blur' }
                    ]
                },
                types:[{
                    value: 1,
                    label: '固定班制'
                }],
                workDates:[],
                classes:{},
                classesAll:[],
                specialDates1:[],
                specialDates2:[],
                modelSign:0
            }
        },
        components: {
            classes,userTransferMore,userTransferSingle,addDateClasses,addDate
        },
        created:function () {
        },
        mounted:function () {
            document.onkeypress = banBackSpace
            document.onkeydown = banBackSpace
        },
        methods:{
            init(data,workDates){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                this.workDates=workDates;
                this.classes={};
                this.classesAll=[];
                this.specialDates1=[];
                this.specialDates2=[];
                // 初始值
                this.form.id=data.id;
                this.form.name=data.name;
                this.form.deptId=data.deptId;

                if(this.$util.isNotEmpty(data.partakeAttendant)){
                    this.form.partakeAttendant=data.partakeAttendant.split(',');
                    this.form.partakeAttendantLabel=data.partakeAttendant.split(',').length+"人";
                }else{
                    this.form.partakeAttendantLabel="请选择";
                    this.form.partakeAttendant=[];
                }

                if(this.$util.isNotEmpty(data.notPartakeAttendant)){
                    this.form.notPartakeAttendant=data.notPartakeAttendant.split(',');
                    this.form.notPartakeAttendantLabel=data.notPartakeAttendant.split(',').length+"人";
                }else{
                    this.form.notPartakeAttendantLabel="请选择";
                    this.form.notPartakeAttendant=[];
                }
                
                if(this.$util.isNotEmpty(data.attendaceController)){
                    this.form.attendaceController=data.attendaceController.split(',');
                    this.form.attendaceControllerLabel=data.attendaceController.split(',').length+"人";
                }else{
                    this.form.attendaceControllerLabel="请选择";
                    this.form.attendaceController=[]
                }
                this.form.classesId=data.classesId;
                // 获取班次，如果班次不存在直接跳过
                this.getClassesData();
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            getClassesData(){
                //班次管理
                let url  = this.listClassesDataUrl;
                let data = {
                    deptId:this.form.deptId
                };
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        if(res.data.list.length == 0){
                            this.$commonFn.showTip('班次不存在，请添加班次，再进行此操作',3);
                            this.visible=false;
                        }
                        this.classesAll=res.data.list;
                        // 默认选中班次
                        for(let i=0;i<this.classesAll.length;i++){
                            if(this.classesAll[i].id == this.form.classesId){
                                this.classes=this.classesAll[i];
                                break;
                            }
                        }
                        // 初始工作日设置
                        this.initWorkDate();
                        // 获取特殊日期
                        this.getSpecialDate();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            setClasses(selecId,index,type){
                //type为1情况下，默认获取当前班次
                if(type == 1){
                    selecId=this.classes.id;
                }
                this.classesVisible=true;
                this.$nextTick(() => {
                    this.$refs['classes'].init(this.form.deptId,selecId,index,type);
                })
            },
            editClasses(rowData,index,type){
                if(type == 1){
                    this.classes=rowData;
                    // 初始所有的班次
                    this.updateWorkDate();
                }else if(type == 2){
                    let name=this.workDates[index].name;
                    let cycleValue=this.workDates[index].cycleValue;
                    let workDate={};
                    workDate.workStatus=1;
                    workDate.name=name;
                    workDate.cycleValue=cycleValue;
                    workDate.classesId=rowData.id;
                    workDate.className=rowData.name;
                    workDate.classesType=rowData.classesType;
                    workDate.oneCommuteTime=rowData.oneCommuteTime;
                    workDate.twoCommuteTime=rowData.twoCommuteTime;
                    workDate.threeCommuteTime=rowData.threeCommuteTime; 
                    this.workDates.splice(index, 1);
                    this.workDates.splice(index,0,workDate);
                    this.$refs.multipleTable.toggleRowSelection(workDate);
                    // console.log("编辑变成行："+JSON.stringify(this.workDates[index]));
                }
            },
            // 通过班次ID，获取班次对象
            getCurrentClasses(classesId){
                for(let i=0;i<this.classesAll.length;i++){
                    if(this.classesAll[i].id == classesId){
                        return this.classesAll[i];
                    }
                }
            },
            // 更改工作日期
            updateWorkDate(){
                let selecRows=[];
                for(var i=0;i<this.workDates.length;i++){
                    let tempData=this.workDates[i];
                    // 工作日
                    if(tempData.workStatus == 1){
                        let workStatus=this.workDates[i].workStatus;
                        let name=this.workDates[i].name;
                        let cycleValue=this.workDates[i].cycleValue;
                        let workDate={};
                        workDate.workStatus=workStatus;
                        workDate.name=name;
                        workDate.cycleValue=cycleValue;
                        workDate.classesId=this.classes.id;
                        workDate.className=this.classes.name;
                        workDate.classesType=this.classes.classesType;
                        workDate.oneCommuteTime=this.classes.oneCommuteTime;
                        workDate.twoCommuteTime=this.classes.twoCommuteTime;
                        workDate.threeCommuteTime=this.classes.threeCommuteTime; 
                        this.workDates.splice(i, 1);
                        this.workDates.splice(i,0,workDate);
                        // 添加选中行数据
                        selecRows.push(workDate);
                    }// 休息
                    else if(tempData.workStatus == 2){
                    }
                }
                this.toggleSelection(selecRows);
            },
            // 初始工作日期
            initWorkDate(){
                let selecRows=[];
                for(var i=0;i<this.workDates.length;i++){
                    let tempData=this.workDates[i];
                    // 工作日
                    if(tempData.workStatus == 1){
                        let workStatus=this.workDates[i].workStatus;
                        let name=this.workDates[i].name;
                        let cycleValue=this.workDates[i].cycleValue;
                        let workDate={};
                        workDate.workStatus=workStatus;
                        workDate.name=name;
                        workDate.cycleValue=cycleValue;
                        let classesData=this.getCurrentClasses(this.workDates[i].classesId);
                        workDate.classesId=classesData.id;
                        workDate.className=classesData.name;
                        workDate.classesType=classesData.classesType;
                        workDate.oneCommuteTime=classesData.oneCommuteTime;
                        workDate.twoCommuteTime=classesData.twoCommuteTime;
                        workDate.threeCommuteTime=classesData.threeCommuteTime; 
                        this.workDates.splice(i, 1);
                        this.workDates.splice(i,0,workDate);
                        // 添加选中行数据
                        selecRows.push(workDate);
                    }// 休息
                    else if(tempData.workStatus == 2){
                    }
                }
                this.toggleSelection(selecRows);
                // console.log("选中行："+JSON.stringify(selecRows));
            },
            // 选中行
            toggleSelection(rows) {
                // console.log("12312323："+JSON.stringify(rows));
                if (rows) {
                    rows.forEach(row => {
                        this.$refs.multipleTable.toggleRowSelection(row);
                    });
                } else {
                    this.$refs.multipleTable.clearSelection();
                }
            },
            handleSelect(selectRows,row){
                var rowIndex=0;
                for (let i = 0;i < this.workDates.length;i++){
                    if(this.workDates[i].name == row.name){
                        rowIndex=i;
                        break;
                    }
                }
                // 获取当前数据如果是工作状态，那这次修改就休息。
                // 工作状态（1-工作，2-休息）
                if(row.workStatus == 1){
                    let workStatus=2;
                    let name=this.workDates[rowIndex].name;
                    let cycleValue=this.workDates[rowIndex].cycleValue;
                    let workDate={};
                    workDate.workStatus=workStatus;
                    workDate.name=name;
                    workDate.cycleValue=cycleValue;
                    this.workDates.splice(rowIndex, 1);
                    this.workDates.splice(rowIndex,0,workDate);
                }else if(row.workStatus == 2){
                    let workStatus=1;
                    let name=this.workDates[rowIndex].name;
                    let cycleValue=this.workDates[rowIndex].cycleValue;
                    let workDate={};
                    workDate.workStatus=workStatus;
                    workDate.name=name;
                    workDate.cycleValue=cycleValue;
                    workDate.classesId=this.classes.id;
                    workDate.className=this.classes.name;
                    workDate.classesType=this.classes.classesType;
                    workDate.oneCommuteTime=this.classes.oneCommuteTime;
                    workDate.twoCommuteTime=this.classes.twoCommuteTime;
                    workDate.threeCommuteTime=this.classes.threeCommuteTime; 
                    this.workDates.splice(rowIndex, 1);
                    this.workDates.splice(rowIndex,0,workDate);
                    this.$refs.multipleTable.toggleRowSelection(workDate);
                }
            },
            selectAll(selectRows){
                for (let i = 0;i < this.workDates.length;i++){
                    let selectVal=false;
                    for (let j = 0;j < selectRows.length;j++){
                        if(this.workDates[i].name == selectRows[j].name){
                            let workStatus=1;
                            let name=this.workDates[i].name;
                            let cycleValue=this.workDates[i].cycleValue;
                            let workDate={};
                            workDate.workStatus=workStatus;
                            workDate.name=name;
                            workDate.cycleValue=cycleValue;
                            workDate.classesId=this.classes.id;
                            workDate.className=this.classes.name;
                            workDate.classesType=this.classes.classesType;
                            workDate.oneCommuteTime=this.classes.oneCommuteTime;
                            workDate.twoCommuteTime=this.classes.twoCommuteTime;
                            workDate.threeCommuteTime=this.classes.threeCommuteTime; 
                            this.workDates.splice(i, 1);
                            this.workDates.splice(i,0,workDate);
                            this.$refs.multipleTable.toggleRowSelection(workDate);

                            selectVal=true;
                            break;
                        }
                    }

                    // 没有选中的
                    if(!selectVal){
                        let workStatus=2;
                        let name=this.workDates[i].name;
                        let cycleValue=this.workDates[i].cycleValue;
                        let workDate={};
                        workDate.workStatus=workStatus;
                        workDate.name=name;
                        workDate.cycleValue=cycleValue;
                        this.workDates.splice(i, 1);
                        this.workDates.splice(i,0,workDate);
                    }
                }
            },
            getMoreUser(type){
                this.userTransferMoreVisible=true;
                this.$nextTick(() => {
                    this.modelSign=type;
                    if(this.modelSign == 1){
                        this.$refs['userTransferMore'].init(2,this.form.partakeAttendant,2,this.form.deptId);
                    }else if(this.modelSign == 2){
                        this.$refs['userTransferMore'].init(2,this.form.notPartakeAttendant,2,this.form.deptId);
                    }
                })
            },
            setUser(data,name){
                 // 参与考勤人员
                 if(this.modelSign == 1){
                    if(data.length == 0){
                        this.form.partakeAttendantLabel="请选择";
                    }else{
                        this.form.partakeAttendantLabel=data.length+"人";
                    }
                     this.form.partakeAttendant=data;
                    // 去除无需考勤人员
                    if(this.form.notPartakeAttendant.length>0){
                        for(let i=0;i<this.form.partakeAttendant.length;i++){
                            for(let j=0;j<this.form.notPartakeAttendant.length;j++){
                                if(this.form.partakeAttendant[i] == this.form.notPartakeAttendant[j]){
                                    this.form.notPartakeAttendant.splice(j, 1);
                                    j--;
                                    break;
                                }
                            }
                        }
                        if(this.form.notPartakeAttendant.length ==0 ){
                            this.form.notPartakeAttendantLabel="请选择";
                        }else{
                            this.form.notPartakeAttendantLabel=this.form.notPartakeAttendant.length+"人";
                        }
                    }
                 }// 无需考勤人员
                 else if(this.modelSign == 2){
                    if(data.length == 0){
                        this.form.notPartakeAttendantLabel="请选择";
                    }else{
                        this.form.notPartakeAttendantLabel=data.length+"人";
                    }
                    this.form.notPartakeAttendant=data;
                    // 去除参与考勤人员存在无需考勤里面
                    for(let i=0;i<this.form.partakeAttendant.length;i++){
                        for(let j=0;j<data.length;j++){
                            if(this.form.partakeAttendant[i] == data[j]){
                                this.form.partakeAttendant.splice(i, 1);
                                i--;
                                break;
                            }
                        }
                    }
                    if(this.form.partakeAttendant.length == 0){
                        this.form.partakeAttendantLabel="请选择";
                    }else{
                        this.form.partakeAttendantLabel=this.form.partakeAttendant.length+"人";
                    }
                 }//考勤负责人
                 else if(this.modelSign == 3){
                    // console.log("选中人员ID："+data+"；名字："+name);
                    this.form.attendaceController=[];
                    if(data == ''){
                        this.form.attendaceControllerLabel="请选择";
                    }else{
                        this.form.attendaceController.push(data);
                        this.form.attendaceControllerLabel=this.form.attendaceController.length+"人";
                    }
                 }
            },
            getSingleUser(){
                this.userTransferSingleVisible=true;
                this.$nextTick(() => {
                    this.modelSign=3;
                    this.$refs['userTransferSingle'].init(2,this.form.attendaceController,1,this.form.deptId);
                })
            },
            // setSingleUser(data){
            //     this.form.attendaceController=data;
            //     this.form.attendaceControllerLabel=data.length+"人";
            // },
            // 必须打卡的日期
            getAddDateClasses(){
                this.addDateClassesVisible=true;
                this.$nextTick(() => {
                    this.$refs['addDateClasses'].init();
                })
            },
            addDateClasses(data){
                //验证必须打卡时间与不要打卡时间不存在才能添加
                if(this.isExistDate(data.date)){
                    this.$commonFn.showTip('该日期已被指定，请重新选择',3);
                    return;
                }
                this.specialDates1.push(data);
            },
            delDateClasses(index){
                this.specialDates1.splice(index, 1);
            },
            // 不用打卡的日期
            getAddDate(){
                this.addDateVisible=true;
                this.$nextTick(() => {
                    this.$refs['addDate'].init();
                })
            },
            addDate(data){
                //验证必须打卡时间与不要打卡时间不存在才能添加
                if(this.isExistDate(data.date)){
                    this.$commonFn.showTip('该日期已被指定，请重新选择',3);
                    return;
                }
                this.specialDates2.push(data);
            },
            delDate(index){
                this.specialDates2.splice(index, 1);
            },
            // 验证当前日期，是否存在
            isExistDate(date){
                let resultVal=false;
                for(let i=0;i<this.specialDates1.length;i++){
                     if(date == this.specialDates1[i].date){
                         resultVal=true;
                         break;
                     }
                }
                if(!resultVal){
                    for(let i=0;i<this.specialDates2.length;i++){
                        if(date == this.specialDates2[i].date){
                            resultVal=true;
                            break;
                        }
                    }
                }
                return resultVal;
            },
            // 获取特殊日期
            getSpecialDate(){
                let url  = this.listSpecialDateUrl;
                let data = {
                    attendaceGroupId:this.form.id
                };
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        let data=res.data.list;
                        // console.log("特殊日期"+JSON.stringify(data));
                        for(let i=0;i<data.length;i++){
                            let specialDate={};
                            specialDate.date=data[i].date;
                            // 打卡标识（1-必须打卡日期，2-不用打卡日期）
                            if(data[i].flag == 1){
                                specialDate.classesId=data[i].classesId;
                                specialDate.flag=1;
                                let classesData=this.getCurrentClasses(data[i].classesId);
                                // console.log("特殊日期"+JSON.stringify(data));
                                specialDate.className=classesData.name;
                                specialDate.classesType=classesData.classesType;
                                specialDate.oneCommuteTime=classesData.oneCommuteTime;
                                specialDate.twoCommuteTime=classesData.twoCommuteTime;
                                specialDate.threeCommuteTime=classesData.threeCommuteTime;
                                this.specialDates1.push(specialDate);
                            }else if(data[i].flag == 2){
                                specialDate.flag=2;
                                this.specialDates2.push(specialDate);
                            }
                        }
                       // console.log("班次"+JSON.stringify(this.classes));
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            save(){
                 this.$refs['form'].validate((valid) => {
                    if(valid){
                        this.form.workDates=[];
                        this.form.specialDates1=[];
                        this.form.specialDates2=[];
                        // 设置工作日
                        for(let i=0;i<this.workDates.length;i++){
                            let workDate={};
                            workDate.classesId=this.workDates[i].classesId;
                            workDate.name=this.workDates[i].name;
                            workDate.cycleValue=this.workDates[i].cycleValue;
                            workDate.workStatus=this.workDates[i].workStatus;
                            this.form.workDates.push(workDate);
                        }
                        // 设置特殊日期必须打卡
                        for(let i=0;i<this.specialDates1.length;i++){
                            let specialDates={};
                            specialDates.classesId=this.specialDates1[i].classesId;
                            specialDates.date=this.specialDates1[i].date;
                            specialDates.flag=1;
                            this.form.specialDates1.push(specialDates);
                        }
                        // 设置特殊日期不需要打卡
                        for(let i=0;i<this.specialDates2.length;i++){
                            let specialDates={};
                            specialDates.date=this.specialDates2[i].date;
                            specialDates.flag=2;
                            this.form.specialDates2.push(specialDates);
                        }

                        let url= this.attendaceGroupUpdateUrl;
                        let data = {
                            id:this.form.id,
                            name:this.form.name,
                            classesId:this.classes.id,
                            partakeAttendant:this.form.partakeAttendant.join(','),
                            notPartakeAttendant:this.form.notPartakeAttendant.join(','),
                            attendaceController:this.form.attendaceController.join(','),
                            type:this.form.type,
                            holidayFlag:this.form.holidayFlag?1:2,
                            workDates:JSON.stringify(this.form.workDates),
                            specialDates1:JSON.stringify(this.form.specialDates1),
                            specialDates2:JSON.stringify(this.form.specialDates2)
                        };
                        // console.log(JSON.stringify(data));
                        // return;
                        this.apiPost(url, data).then((res) => {
                            if(res.status == 200){
                                this.$commonFn.showTip(res.message,1);
                                this.visible=false;
                                this.$parent.getData();
                            }else{
                                this.$commonFn.showTip(res.message,3);
                            }
                        }, (err) => {
                            console.log(err);
                        });
                    }
               });
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
    .el-row {
        margin-bottom: 20px;
    }
    .el-col {
        border-radius: 4px;
    }
    .bg-purple-dark {
        background: #99a9bf;
    }
    .bg-purple {
        background: #d3dce6;
    }
    .bg-purple-light {
        background: #e5e9f2;
    }
    .grid-content {
        border-radius: 4px;
        min-height: 20px;
    }
    .row-bg {
        padding: 10px 0;
        background-color: #f9fafc;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/attendance/group/Update.vue